import React, { useCallback } from 'react'
import Text from 'core/elements/Text'
import { updateVolume, bootableVolume } from './actions'
import useUpdateAction from 'core/hooks/useUpdateAction'
import ModalForm from 'core/elements/modal/ModalForm'
import useParams from 'core/hooks/useParams'
import TextField from 'core/components/validatedForm/TextField'
import Theme from 'core/themes/model'
import { makeStyles } from '@material-ui/styles'
import CheckboxField from 'core/components/validatedForm/CheckboxField'

export default function EditVolumeDialog({ rows: volumes, onClose, reloadVolumes }) {
  const volume = volumes?.[0]
  const classes = useStyles()
  const defaultParams = {
    name: volume?.name,
    description: volume?.description,
    bootable: volume?.bootable === 'true',
  }
  const { params, getParamsUpdater, setParams } = useParams(defaultParams)

  const { update, updating, error, reset } = useUpdateAction(updateVolume)

  const {
    update: updateBootVolume,
    error: bootVolumeError,
    reset: bootVolumeReset,
  } = useUpdateAction(bootableVolume)

  const submitForm = useCallback(async () => {
    const body = {
      volume: {
        name: params.name,
        description: params.description,
      },
    }
    const updateBootable =
      (volume.bootable === 'true' && !params.bootable) ||
      (volume.bootable === 'false' && params.bootable)
    const { success } = await update({
      id: volume.id,
      body,
    })
    if (updateBootable) {
      const { success: bootSuccess } = await updateBootVolume({
        id: volume.id,
        isBootable: params.bootable,
      })
      if (success && bootSuccess) {
        reloadVolumes?.()
        handleClose(true)
      }
    } else {
      if (success) {
        reloadVolumes?.()
        handleClose(true)
      }
    }
  }, [volume, params])

  const handleClose = (success?: boolean) => {
    setParams(defaultParams)
    reset()
    bootVolumeReset()
    onClose(success)
  }

  return (
    <ModalForm
      open
      panel="dialog"
      title={`Edit Volume`}
      onSubmit={submitForm}
      onClose={onClose}
      submitting={updating}
      error={error || bootVolumeError}
      submitTitle={`Update Volume`}
    >
      <div className={classes.body}>
        <TextField
          id="name"
          label="Name"
          onChange={getParamsUpdater('name')}
          value={params.name}
          required
        />
        <TextField
          id="description"
          label="Description"
          onChange={getParamsUpdater('description')}
          value={params.description}
        />
        <CheckboxField
          id="bootable"
          label="Make Bootable"
          onChange={getParamsUpdater('bootable')}
          value={params.bootable}
        />
      </div>
    </ModalForm>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  body: {
    display: 'grid',
    gap: 12,
  },
}))
